<template>
  <dropdown ref="dropdown" label="Sort" classes="PaB-product-sort" buttonType="plain" :direction="['down', 'left']">
    <template slot="icon">
      <icon-base icon-name="Sort" width="25" height="25">
        <icon-sort />
      </icon-base>
    </template>
    <template slot="content">
      <ul class="PaB-product-sort__options">
        <li v-for="sort in sortingOptions" :key="sort.key" @click="setSort($event, sort.field, sort.dir)" class="PaB-product-sort__option" :class="{'PaB-product-sort__option--current': isCurrentSort(sort)}">
          <icon-base width="16" height="16" v-if="isCurrentSort(sort)">
            <icon-check></icon-check>
          </icon-base>
          <icon-base width="16" height="16" v-else></icon-base>
          <span class="PaB-product-sort__option-label">{{ sort.label }}</span>
        </li>
      </ul>
    </template>
  </dropdown>
</template>

<style lang="scss" scoped>
body {
  .PaB-product-sort {
    &.is-open {
      .PaB-button {
        border: 1px solid rgba(#7f7f7f, 0.5);
      }
    }
  }

  ul.PaB-product-sort__options {
    margin: 0;
    padding: 0;
    margin-left: -10px;
  }

  .PaB-product-sort__option {
    white-space: nowrap;
    display: block;
    cursor: pointer;
    svg {
      margin-right: 0.25em;
    }
  }
}
</style>

<script>
import Dropdown from '@/components/Dropdown'
import IconBase from '@/components/IconBase'
import IconSort from '@/components/icons/IconSort'
import IconCheck from '@/components/icons/IconCheck'

export default {
  components: {
    Dropdown,
    IconBase,
    IconSort,
    IconCheck
  },

  data: function () {
    return {
      sortingOptions: [
        {
          label: 'Name - A to Z',
          field: 'name',
          dir: 1
        }, {
          label: 'Name - Z to A',
          field: 'name',
          dir: -1
        }, {
          label: 'Price - Low to High',
          field: 'price',
          dir: 1
        }, {
          label: 'Price - High to Low',
          field: 'price',
          dir: -1
        }, {
          label: 'THC - Low to High',
          field: 'thc',
          dir: 1
        }, {
          label: 'THC - High to Low',
          field: 'thc',
          dir: -1
        }, {
          label: 'CBD - Low to High',
          field: 'cbd',
          dir: 1
        }, {
          label: 'CBD - High to Low',
          field: 'cbd',
          dir: -1
        }, {
          label: 'Vendor - A to Z',
          field: 'brand',
          dir: 1
        }, {
          label: 'Vendor - Z to A',
          field: 'brand',
          dir: -1
        }
      ]
    }
  },
  computed: {
    current_sort () {
      return this.$store.state.products.sort
    }
  },
  methods: {
    setSort: function (e, field, dir) {
      this.$refs.dropdown.close()
      this.$nextTick(() => {
        this.$store.dispatch('products/setSort', { field: field, dir: dir })
      })
    },
    isCurrentSort: function (sort) {
      return sort.field === this.current_sort.field && sort.dir === this.current_sort.dir
    }
  }
}
</script>
